import Vue from 'vue';
import numeral from 'numeral'
import vueNumeralFilterInstaller from 'vue-numeral-filter'

numeral.register('locale', 'id', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'ribu',
    million: 'juta',
    billion: 'milyar',
    trillion: 'trilyun'
  },
  ordinal: function(number) {
    return number === 1 ? '' : ''
  },
  currency: {
    symbol: 'Rp. '
  }
})

Vue.use(vueNumeralFilterInstaller, { locale: 'id' })
